export enum RequestValidationTriggers {
    SUBMIT = 'submit',
    CHANGE = 'change',
    INPUT = 'input',
    NEVER = 'never'
}
export enum TypeOfValidations {
    SILENT = 'silent',
    WITH_ERRORS = 'with-errors'
}
